import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "value", "onValueChange", "isMobile"],
  _excluded2 = ["children"],
  _excluded3 = ["children", "className", "value"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as t, Fragment as f, jsxs as I } from "react/jsx-runtime";
import u from "classnames";
import v, { useCallback as b, useMemo as N, useContext as m, useRef as h } from "react";
import { useId as k } from "@react-aria/utils";
import R from "../../assets/icons/chevron-down.svg.js";
import T from "../../assets/icons/chevron-down-mobile.svg.js";
import V from "../../assets/icons/forward-arrow.svg.js";
import w from "../Button/Button.js";
import * as C from "@radix-ui/react-accordion";
import n from "./NavigationMenuPrimitive.module.scss.js";
import M from "../../hooks/useClickOutside.js";
var p = v.createContext(null),
  q = function q(_ref) {
    var e = _ref.children,
      o = _ref.value,
      r = _ref.onValueChange,
      i = _ref.isMobile,
      a = _objectWithoutProperties(_ref, _excluded);
    var s = b(function (l) {
        r(l === o ? "" : l);
      }, [o, r]),
      c = N(function () {
        return {
          onTriggerClick: s,
          value: o,
          isMobile: i
        };
      }, [s, o, i]);
    return /* @__PURE__ */t(p.Provider, {
      value: c,
      children: /* @__PURE__ */t("nav", _objectSpread(_objectSpread({}, a), {}, {
        children: e
      }))
    });
  },
  z = v.forwardRef(function (_ref2, r) {
    var e = _ref2.children,
      o = _objectWithoutProperties(_ref2, _excluded2);
    var _m = m(p),
      i = _m.isMobile;
    return i ? /* @__PURE__ */t(C.Root, {
      className: n.accordionRoot,
      type: "single",
      collapsible: !0,
      children: e
    }) : /* @__PURE__ */t("ul", _objectSpread(_objectSpread({}, o), {}, {
      ref: r,
      children: e
    }));
  }),
  x = v.createContext(null),
  E = function E(_ref3) {
    var e = _ref3.children,
      o = _ref3.className,
      r = _ref3.value,
      i = _objectWithoutProperties(_ref3, _excluded3);
    var a = m(p),
      s = k(),
      c = s === a.value ? "open" : "closed",
      l = N(function () {
        return {
          itemId: s,
          state: c
        };
      }, [s]),
      d = h(null),
      g = a.isMobile;
    return M(d, function () {
      c === "open" && !g && a.onTriggerClick(s);
    }), /* @__PURE__ */t(x.Provider, {
      value: l,
      children: g ? /* @__PURE__ */t(C.Item, {
        className: u([n.item, o]),
        value: r,
        children: e
      }) : /* @__PURE__ */t("li", _objectSpread(_objectSpread({
        ref: d
      }, i), {}, {
        className: u([n.item, o]),
        "data-state": c,
        children: e
      }))
    });
  },
  D = function D() {
    return /* @__PURE__ */I(f, {
      children: [/* @__PURE__ */t(V, {
        className: u([n.icon, n.mbIcon])
      }), /* @__PURE__ */t(R, {
        className: u([n.icon, n.dxIcon])
      })]
    });
  },
  G = function G(_ref4) {
    var e = _ref4.children,
      o = _ref4.endIcon,
      r = _ref4.startIcon,
      i = _ref4.href;
    var a = m(x),
      s = m(p),
      c = function c(g) {
        g.preventDefault(), s.onTriggerClick(a.itemId);
      },
      l = s.isMobile,
      d = a.state === "open";
    return /* @__PURE__ */t(f, {
      children: l ? /* @__PURE__ */I(C.Trigger, {
        className: n.accordionTrigger,
        children: [e, /* @__PURE__ */t(T, {
          className: n.accordionChevron
        })]
      }) : /* @__PURE__ */t(f, {
        children: /* @__PURE__ */t(w, {
          height: "full",
          "aria-haspopup": "true",
          "aria-expanded": d,
          variant: "text",
          href: i,
          role: "button",
          color: "geekblue-800",
          onClick: c,
          underline: !1,
          endIcon: o === null ? null : o || /* @__PURE__ */t(D, {}),
          startIcon: r,
          poppinsFont: !0,
          children: e
        })
      })
    });
  },
  H = function H(_ref5) {
    var e = _ref5.children;
    var o = m(x),
      r = m(p),
      i = o.itemId === r.value ? "open" : "closed";
    return r.isMobile ? /* @__PURE__ */t(C.Content, {
      className: n.accordionContent,
      children: e
    }) : /* @__PURE__ */t("div", {
      className: u([n.menuContentViewPort, n.menuContent]),
      "data-state": i,
      children: e
    });
  };
export { H as Content, E as Item, z as List, q as Root, G as Trigger };